import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {withAlert} from 'react-alert';
import {createUser} from "../auth/Auth";
import {postRequest} from "../routes/Routes";
import '../assets/css/Home.css';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {loading: false};
    }

    render() {
        return (
            <div className={this.props.component === 'Checkout' ? "" : "container"}>
                <div className={this.props.component === 'Checkout' ? "" : "login-component"}>
                    <h1 className="heading">volkslanka</h1>
                    <h3 className="form-heading">Login to your account.</h3>
                    <form onSubmit={this.loginFunction}>
                        <div className="form-group">
                            <input type="email" className="form-control"
                                   placeholder='Email Address' id="email" required/>
                        </div>
                        <div className="form-group">
                            <input className="form-control" type="password"
                                   placeholder='Password' id="password" minLength="8" required/>
                        </div>
                        <NavLink to="/forgot-password">Forgot your password?</NavLink>
                        <button className="btn blue-button login-button" disabled={this.state.loading}>
                            {this.state.loading ?
                                <span className="spinner-grow spinner-grow-sm ml-1" role="status" aria-hidden="true"/>
                                : null
                            }
                            Log in
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    loginFunction = async (event) => {
        this.setState({loading: true});
        event.preventDefault();
        let values = {
            email: event.target.email.value,
            password: event.target.password.value,
            endpoint: '/api/login'
        };
        postRequest(values).then(response => {
            if (response.status === 200) {
                if (response.data.error) {
                    this.props.alert.error(response.data.message);
                } else {
                    let user = response.data.user;
                    if (user.role_id === 2) {
                        postRequest({
                            email: user.email,
                            endpoint: '/api/partners/user',
                            token: user.api_token
                        }).then(response => {
                            if (response.status === 200) {
                                if (response.data.error) {
                                    this.props.alert.error(response.data.message);
                                } else {
                                    user = {...user, partner: response.data.partner ? response.data.partner : {}};
                                    this.createUser(user);
                                }
                            } else {
                                this.props.alert.error(response.data.message);
                            }
                        });
                    } else {
                        this.createUser(user);
                    }
                }
            } else {
                this.setState({error: true, errorMessage: 'An error occurred!'});
            }
            this.setState({loading: false});
        });
    }

    createUser = (user) => {
        createUser(user).then(() => {
            this.props.history.go(
                this.props.history.push(this.props.component === 'Checkout' ? {pathname: '/checkout'} : {pathname: "/"})
            );
        });
    }
}

export default withAlert()(withRouter(Login));